export default "__VITE_ASSET__DgdKJR8C__"